<template>
  <div class="links-btn" v-if="isAuthenticated">
    <a class="btn border white" href="#" id="loginLink" @click.prevent="logout">{{ $t('Déconnecter') }}</a>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { moduleNames, actionTypes } from '@Store/access-keys'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated'])
  },
  methods: {
    logout() {
      this.$auth.logout()
      this.$router.push('/')
      this.resetMeterReadingForm()
      this.resetConsumptionHistoryForm()
      this.resetAppointmentForm()
    },
    ...mapActions(moduleNames.meterReading, {
      resetMeterReadingForm: actionTypes.meterReading.RESET_FORM
    }),
    ...mapActions(moduleNames.consumption, {
      resetConsumptionHistoryForm: actionTypes.consumption.RESET_FORM
    }),
    ...mapActions(moduleNames.appointment, {
      resetAppointmentForm: actionTypes.appointment.RESET_FORM
    })
  }
}
</script>
